import { ShotCard } from "./ShotCard";
import { ItemRow } from "./ItemRow";
import { DimsRow } from "./DimsRow";

export const RoomView = ({ insp, room, onUploaded, onSet, onDims }) => {
  const photos = insp.photos?.[room.key] || {};
  const findings = insp.findings || {};
  const extraShot = { key: "extra", label: "Extra detail shot", tip: "Close-up of any damage, serial plate, or anything you want on record.", required: false };

  return (
    <section className="insp-room" data-testid={`insp-room-${room.key}`}>
      <h2 className="insp-room__title">{room.label}</h2>
      <div className="insp-step-label">Step 1 · Photos</div>
      <div className="insp-shots">
        {[...room.shots, extraShot].map((s) => (
          <ShotCard key={s.key} inspectionId={insp.inspection_id} roomKey={room.key} shot={s}
                    photoIds={photos[s.key] || []} onUploaded={onUploaded} locked={insp.status === "completed"} />
        ))}
      </div>
      {["living", "kitchen", "bathroom", "bedroom"].includes(room.type) && (
        <DimsRow insp={insp} room={room} onSaved={onDims} />
      )}
      <div className="insp-step-label">Step 2 · Condition</div>
      <div className="insp-items">
        {room.items.map((it) => (
          <ItemRow key={it.key} roomKey={room.key} item={it} finding={findings[`${room.key}::${it.key}`]} onSet={onSet} />
        ))}
      </div>
    </section>
  );
};
